import { Box, Flex, Text, transition } from "@chakra-ui/react";
import React, { useState } from "react";
import {Link} from 'react-scroll'
import '../App.css';

export default function NavLink({ text, to }) {
  const [click,setclick]=useState(false)
  const handleClick=()=>{
    setclick(!click)
  }
  const closeMenu=()=>{
    setclick(false)
  }

  return (
    <Link to={to} spy={true} smooth={true} offset={-100} duration={500}>
      <Flex
      role={"group"}
      padding={2}
      borderRadius={5}
      _hover={{
       
      }}
       
      >
        <Text  color={"cplite"}
         _groupHover={{
            color: "white",
            transition: 10,
            cursor: "pointer",
          }}
        >{"< "}</Text>
       
        &nbsp;
        <Text color={"white"}
        transition="all .25s ease"
         _groupHover={{
            color: "cplite",
            transition: 10,
            cursor: "pointer",
            transform:'scale(1.1)'
          }}
        >{text}</Text>
        
        &nbsp;
        <Text color={"cplite"}
         _groupHover={{
            color: "white",
            transition: 10,
            cursor: "pointer",
          }}
        >{" />"}</Text>
      </Flex>
    </Link>
  );
}
